import { call, put, all, fork, takeEvery } from "redux-saga/effects";

import { blogHeaderRedux } from "./reducers";
import { BlogHeaderDetails } from "@/app/service/Blogs";
import { CreateEmailSubscription } from "@/app/service/Subscribe";

function* getBlogHeaderSaga(action) {
  try {
    const response = yield call(BlogHeaderDetails, action.payload);

    yield put(blogHeaderRedux.actions.getBlogHeaderSuccess(response.data));
  } catch (error) {
    yield put(blogHeaderRedux.actions.getBlogHeaderFailure(error));
  }
}

// subscribe
function* createSubscribeSaga(action) {
  try {
    const response = yield call(CreateEmailSubscription, action.payload);
    yield put(blogHeaderRedux.actions.createSubscribeSuccess(response.data));
  } catch (error) {
    yield put(blogHeaderRedux.actions.createSubscribeFailure(error));
  }
}

export function* watchBlogHeader() {
  yield takeEvery(
    blogHeaderRedux.actions.getBlogHeaderRequest.type,
    getBlogHeaderSaga
  );
}

export function* watchCreateSubscribe() {
  yield takeEvery(
    blogHeaderRedux.actions.createSubscribeRequest.type,
    createSubscribeSaga
  );
}

export default function* blogHeaderSaga() {
  yield all([fork(watchBlogHeader)]);
  yield all([fork(watchCreateSubscribe)]);
}
